import { ready } from '~/core'
import addEvents from '~/utils/addEvents'

/**
 * DEV NOTE:
 * This JS will handle the association of tabs + content
 * it assumes that the # of "tabs" will always match the # of `.tab-card-menu__card-list` elements
 * it also assumes that the order of the "tabs" will match the order of the sections
 */

ready('tab-card-menu', '.tab-card-menu', (root) => {
  const tabList = [...root.querySelectorAll('.tab-card-menu__subject-wrapper')]
  const contentList = [...root.querySelectorAll('.tab-card-menu__card-list')]
  const selectElement = root.querySelector('.tab-card-menu__select')

  let activeTabIndex = 0

  setupTabAssociations()
  attachTabClickEvents()
  setActiveTab(activeTabIndex)
  attachSelectListener()

  function setupTabAssociations() {
    tabList.forEach((element, index) => {
      tabList[index].dataset.tab = index
      contentList[index].dataset.tab = index
    })
  }

  function attachTabClickEvents() {
    ;[...tabList].forEach((element, index) => {
      addEvents(element, 'click.stop', () => {
        setActiveTab(index)
      })
    })
  }

  function attachSelectListener() {
    selectElement.addEventListener('change', () => {
      const index = selectElement.selectedIndex

      setActiveTab(index)
    })
  }

  function setActiveTab(index = null) {
    // unset active tab + content
    tabList.forEach((element) => element.classList.remove('active'))
    contentList.forEach((element) => element.classList.remove('active'))

    // set new active tab
    activeTabIndex = index
    tabList[activeTabIndex].classList.add('active')

    // show active tab content
    contentList[activeTabIndex].classList.add('active')
  }
})
